import clsx from 'clsx'
import React from 'react'
import { AiOutlineFilePdf } from 'react-icons/ai'
import {
  CloseCircle,
  DocumentDownload,
  DocumentUpload,
  Gallery,
  Music
} from 'iconsax-react'
import { useTheme } from '@mui/material'

import { FILE_EXTENSION } from '@SonarCX/components/molecules/TaskNote'
import { EMAIL_FILE_EXTENSION } from '@SonarCX/slices/extensionAPI'
import TaskAudioFile from './Audio'
import useMediaHandle from '@SonarCX/hooks/useMediaHandle'

interface TaskFileProps {
  file: Media
  index: number
  classes: any
  removeFile: (index: number, file: Media) => void
  setViewingFile: (file: Media) => void
}

const TaskFile: React.FC<TaskFileProps> = ({
  file,
  index,
  classes,
  removeFile,
  setViewingFile
}) => {
  const { download } = useMediaHandle({ media: file, manualEndLoad: true })
  const theme = useTheme()
  const ICON_MAP = {
    'image/png': Gallery,
    'image/jpeg': Gallery,
    'application/pdf': AiOutlineFilePdf,
    'audio/aac': Music,
    audio: Music
  }

  const Icon = ICON_MAP[file.mime] ?? ICON_MAP[file.type] ?? DocumentUpload

  //@ts-ignore
  const name = file.filename ?? file.name
  const type = file.type ?? ''

  const handleOnClick = React.useCallback(() => {
    if (file.id) {
      setViewingFile(file)
    }
  }, [file, setViewingFile])

  if (name.endsWith(FILE_EXTENSION) || name.endsWith(EMAIL_FILE_EXTENSION)) {
    return null
  }

  return (
    <div
      onClick={handleOnClick}
      className={clsx(
        classes.center,
        classes.file,
        file.id && classes.clickable
      )}
    >
      <Icon className={classes.fileIcon} />

      <div
        className={clsx(classes.text, type === 'audio' && classes.audioText)}
      >
        {name}

        {type === 'audio' && <TaskAudioFile file={file} classes={classes} />}

        <span>
          <DocumentDownload
            size={theme.size.base}
            style={{ marginLeft: '0.45rem', cursor: 'pointer' }}
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              download()
            }}
          />

          <CloseCircle
            size={theme.size.base}
            style={{ marginLeft: '0.45rem', cursor: 'pointer' }}
            onClick={e => {
              e.stopPropagation()
              e.preventDefault()
              removeFile(index, file)
            }}
          />
        </span>
      </div>
    </div>
  )
}

export default React.memo(TaskFile)
